import { UNIFORM_GROUP_INDEX_COLORPICKING } from '../constants';
//namespace Pacem.Drawing3D.WebGPU {
/**
 * Generate a WGSL piece of code that eases 3D picking using color strategy.
 */
export function getColorPickingFragmentWgsl(groupIndex = UNIFORM_GROUP_INDEX_COLORPICKING) {
    return `struct ColorPicker {
    id: u32,
  };

  @group(${groupIndex}) @binding(0) var<uniform> colorPicker: ColorPicker;

  @fragment
  fn main(@builtin(position) position: vec4f) -> @location(0) u32 {
    return colorPicker.id;
  }
  `;
}
